const comments = [
  {
    id: 1,
    name: '吃瓜群众小王',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20user%20avatar%20circle%20with%20warm%20amber%20gradient%20background%2C%20minimalist%20modern%20style%2C%20no%20text%2C%20no%20people&width=80&height=80&seq=avatar-1-51hl&orientation=squarish',
    time: '2小时前',
    content: '这个平台真的太宝藏了！51黑料视频更新速度超级快，每次娱乐圈有新瓜都能第一时间看到，画质还特别清晰。',
  },
  {
    id: 2,
    name: '资深八卦爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20user%20avatar%20circle%20with%20dark%20coral%20gradient%20background%2C%20minimalist%20modern%20style%2C%20no%20text%2C%20no%20people&width=80&height=80&seq=avatar-2-51hl&orientation=squarish',
    time: '5小时前',
    content: '追了这么多吃瓜平台，还是51黑料网在线观看最靠谱，内容全而且分类清晰，一区二区找起来特别方便。',
  },
  {
    id: 3,
    name: '每日必刷黑料',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20user%20avatar%20circle%20with%20warm%20golden%20gradient%20background%2C%20minimalist%20modern%20style%2C%20no%20text%2C%20no%20people&width=80&height=80&seq=avatar-3-51hl&orientation=squarish',
    time: '8小时前',
    content: '51黑料吃瓜视频的质量真的没得说，比别家流畅多了，而且没有烦人的弹窗广告，体验一级棒。',
  },
  {
    id: 4,
    name: '八卦研究院',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20user%20avatar%20circle%20with%20deep%20rose%20gradient%20background%2C%20minimalist%20modern%20style%2C%20no%20text%2C%20no%20people&width=80&height=80&seq=avatar-4-51hl&orientation=squarish',
    time: '12小时前',
    content: '作为一个老吃瓜人，51黑料在线看是我用过最好的平台，内容更新快、分类全，关键是不卡顿。',
  },
  {
    id: 5,
    name: '娱乐圈前线记者',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20user%20avatar%20circle%20with%20warm%20copper%20gradient%20background%2C%20minimalist%20modern%20style%2C%20no%20text%2C%20no%20people&width=80&height=80&seq=avatar-5-51hl&orientation=squarish',
    time: '16小时前',
    content: '每天打开51黑料已经成为习惯了，黑料视频观看体验很好，推荐给了好多朋友，都说不错。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            网友热议
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            来看看其他用户对51黑料在线观看的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((c) => (
            <div
              key={c.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}